/**
 * 눌리고 초점 잡히는 느낌.
 *
 * 색만 바뀌면 "눌렸나?" 싶다. 특히 마우스를 올린 채로 누르면 hover 색과
 * active 색이 비슷해 구분이 안 된다. 크기가 아주 살짝 줄면 손끝에 닿은
 * 느낌이 난다.
 *
 * 값은 여기 한 곳에만 둔다. 컴포넌트마다 적어두면 어떤 버튼은 눌리고 어떤
 * 버튼은 안 눌리는 상태가 되고, 그게 지금까지의 상태였다.
 */

/**
 * 눌린 느낌. **120ms를 넘기지 않는다** — 길면 연달아 누를 때 앞 동작이 밀려
 * 굼떠 보인다. 움직임을 원하지 않는 사람에게는 index.css가 전역으로 꺼준다.
 */
export const PRESS =
  "transition-[color,background-color,border-color,transform] duration-120 ease-out-soft active:scale-[0.985]";

/**
 * 크기는 그대로 두고 색만 바뀌는 판.
 *
 * 목록 행처럼 가로로 꽉 찬 것에 쓴다. 꽉 찬 것이 오그라들면 옆 행과 어긋나
 * 보여서, 눌렀다기보다 화면이 흔들린 것처럼 읽힌다.
 */
export const PRESS_FLAT =
  "transition-[color,background-color,border-color] duration-120 ease-out-soft";

/**
 * 키보드로 옮겨 다닐 때 지금 어디인지 보인다.
 *
 * `focus-visible`이라 마우스로 누를 때는 나오지 않는다. `outline-none`으로
 * 브라우저 기본 테두리를 지우기만 하고 대체물을 안 주면, 키보드만 쓰는 사람은
 * 화면에서 길을 잃는다.
 */
export const FOCUS =
  "outline-none focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-ink";

/** 다크 레일 위에서는 검은 테두리가 안 보인다. */
export const FOCUS_ON_DARK =
  "outline-none focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-paper";

/** 누를 수 있는 것에 기본으로 붙는 한 벌. */
export const INTERACTIVE = `${PRESS} ${FOCUS}`;
